import script from "./CcsReportView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CcsReportView.vue?vue&type=script&lang=ts&setup=true"

import "./CcsReportView.vue?vue&type=style&index=0&id=31087bac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31087bac"]])

export default __exports__